function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5A5A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB400",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5A5A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB400",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5A5A",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB400",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Company/Logo/Large",
  transform: "translate(3.000000, 3.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.9600293,39.8135654 C33.8738295,40.9347511 32.2867686,41.5292838 30.2716354,41.4988806 C28.5336052,41.4726581 26.4483887,40.9723971 24.1636855,40.0155078 C19.9506827,38.2509996 14.9982573,34.9206087 10.3204147,30.4177557 C5.64206106,25.9144106 2.12986556,21.0964328 0.21352715,16.960648 C-0.82639682,14.7163149 -1.40096474,12.6548458 -1.48797697,10.9230657 C-1.58894676,8.91349227 -1.04790448,7.30934953 0.039970651,6.1864346 C1.12617053,5.06524887 2.71323139,4.47071618 4.72836463,4.50111945 C6.46639479,4.52734193 8.55161131,5.0276029 10.8363145,5.98449221 C15.0493173,7.74900038 20.0017427,11.0793913 24.6795853,15.5822443 C29.3579389,20.0855894 32.8701344,24.9035672 34.7864728,29.039352 C35.8263968,31.2836851 36.4009647,33.3451542 36.487977,35.0769343 C36.5889468,37.0865077 36.0479045,38.6906505 34.9600293,39.8135654 Z",
  id: "Oval",
  fill: "url(#linearGradient-1)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-Copy",
  fill: "url(#linearGradient-2)",
  cx: 27.5,
  cy: 22.5,
  rx: 10,
  ry: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.6491991,51.8208233 C23.2638302,51.0452715 22.2852089,49.6591109 21.817056,47.7134933 C21.4125319,46.0323132 21.3937502,43.9022663 21.7817257,41.4696188 C22.4949621,36.9975505 24.5814613,31.4380223 27.902206,25.8610039 C31.2198478,20.2891965 35.1370149,15.7610826 38.771384,12.9286538 C40.7372688,11.3965506 42.6357453,10.3525256 44.3288836,9.85476128 C46.275422,9.28250005 47.9827512,9.41332054 49.3508009,10.1791767 C50.7361698,10.9547285 51.7147911,12.3408891 52.182944,14.2865067 C52.5874681,15.9676868 52.6062498,18.0977337 52.2182743,20.5303812 C51.5050379,25.0024495 49.4185387,30.5619777 46.097794,36.1389961 C42.7801522,41.7108035 38.8629851,46.2389174 35.228616,49.0713462 C33.2627312,50.6034494 31.3642547,51.6474744 29.6711164,52.1452387 C27.724578,52.7175 26.0172488,52.5866795 24.6491991,51.8208233 Z",
  id: "Oval-Copy-2",
  fill: "url(#linearGradient-3)"
}))));

var SvgCompanyLogo = function SvgCompanyLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 57 57",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompanyLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/company-logo.1833b14e.svg";
export { ForwardRef as ReactComponent };